<template>
  <!-- telefon (ispod 768px): traka sa tekstom ispod zaglavlja; klizi levo-desno, a pri skrolu nadole se sakrije -->
  <nav class="mt-nav d-md-none" :class="{ 'mt-hidden': hidden }" aria-label="Glavna navigacija">
    <ul ref="listRef" class="mt-list">
      <!-- pun meni sajta (isto sto je radilo dugme sa tri crtice) -->
      <li>
        <button type="button" class="mt-link mt-menu" @click="$emit('menu')">
          Meni <i class="esei icon-chevron-down" aria-hidden="true"></i>
        </button>
      </li>

      <li v-for="item in items" :key="item.key">
        <NuxtLink :to="item.to"
                  class="mt-link"
                  :class="{ on: activeKey === item.key }"
                  :aria-current="activeKey === item.key ? 'page' : null">
          {{ item.label }}
        </NuxtLink>
      </li>
    </ul>
  </nav>
</template>

<script setup>
defineEmits(['menu'])

const route = useRoute()

// link ka kalendaru dogadjaja za tekuci mesec i godinu (kao u glavnom meniju sajta)
const months = ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar']
const now = new Date()

const items = [
  { key: 'home', label: 'Početna', to: '/' },
  { key: 'prices', label: 'Cene', to: '/cena-na-pijacama' },
  { key: 'ads', label: 'Oglasi', to: '/oglasi/svi-oglasi/1' },
  {
    key: 'events',
    label: 'Događaji',
    to: { name: 'kalendar-dogadjaja-dogadjaji-year-month-page', params: { year: now.getFullYear(), month: months[now.getMonth()], page: 1 } },
  },
  { key: 'history', label: 'Istorija', to: '/cene-istorija/cene-stoke-na-pijacama' },
  { key: 'recipes', label: 'Recepti', to: { name: 'recepti-page', params: { page: 1 } } },
]

// koja stavka je aktivna (po adresi); istorija pre cena, jer i ona pocinje sa "cene"
const activeKey = computed(() => {
  const path = route.path

  if (path === '/') return 'home'
  if (path.startsWith('/cene-istorija')) return 'history'
  if (path.startsWith('/oglas')) return 'ads'
  if (path.startsWith('/kalendar-dogadjaja')) return 'events'
  if (path.startsWith('/recept')) return 'recipes'
  if (/^\/(cena|cene|cijen|cijena|stocna-hrana)/.test(path)) return 'prices'

  return null
})

const listRef = ref(null)
const hidden = ref(false)
let lastY = 0

// aktivna stavka se dovodi na sredinu trake
const centerActive = () => {
  const list = listRef.value
  const active = list?.querySelector('.on')

  if (!list || !active) return

  const pinned = list.firstElementChild?.offsetWidth ?? 0

  list.scrollLeft = active.offsetLeft - pinned - (list.clientWidth - pinned - active.offsetWidth) / 2
}

// skrol nadole sakriva traku, skrol nagore je vraca
const onScroll = () => {
  const y = window.scrollY

  if (Math.abs(y - lastY) < 8) return

  hidden.value = y > lastY && y > 140
  lastY = y
}

onMounted(() => {
  lastY = window.scrollY
  window.addEventListener('scroll', onScroll, { passive: true })
  nextTick(centerActive)
})

onBeforeUnmount(() => window.removeEventListener('scroll', onScroll))

watch(() => route.path, () => {
  hidden.value = false
  nextTick(centerActive)
})
</script>
